import OrganizationCard from "./OrganizationCard";
import celluleUrgenceImg from "../images/cellule.jpeg";

function TrustedSites() {
  const trustedSites = [
    {
      name: "Continuité pédagogique Nomad Education Mayotte",
      objective:
        "Mode d'emploi : Télécharger l'application Nomad Education dans l'Appstore ou Google Play ou aller sur notre site www.nomadeducation.fr. Créer un compte parents. Attention bien indiquer que vous êtes en France puis le code postal de votre ville à Mayotte. Vous avez droit à 5 accès sous un compte, indiquer les classes des enfants. Email : support@nomadeducation.fr",
      verificationDate: "05/01/2025",
      link: "https://www.nomadeducation.fr/",
    },
    {
      name: "Site Chido Mayotte",
      objective:
        "Chidomayotte.info a pour vocation de centraliser les informations liées à la crise Chido à Mayotte.",
      verificationDate: "27/12/2024",
      link: "https://chidomayotte.info/",
    },
    {
      name: "Urgence Mayotte : Déclarez votre situation",
      objective:
        "Site qui permet de visualiser sur une carte les messages qui viennent de Mayotte. Réalisé par Claude Jaquier et Benoit Gambier",
      verificationDate: "18/12/2024",
      link: "https://urgence-mayotte.yt/",
    },
    {
      name: "État du Réseau à Mayotte",
      objective:
        "Site qui permet de suivre en live l'état du réseau à Mayotte. Réalisé par Arthur Boval",
      verificationDate: "18/12/2024",
      link: "https://mayotte-network-status.vercel.app/",
    },
    {
      name: "CELLULE D'URGENCE MÉDICO-PSYCHOLOGIQUE",
      objective:
        "Le passage du cyclone CHIDO, particulièrement violent et destructeur, est un événement psychologiquement éprouvant.",
      verificationDate: "18/12/2024",
      imageUrl: celluleUrgenceImg,
      link: "https://x.com/Prefet976/status/1869357211694363124",
      phone: "+33 (0)1 44 49 24 30",
    },
  ];

  return (
    <div className="trusted-sites-grid">
      {trustedSites.map((site, index) => (
        <OrganizationCard
          key={index}
          organization={site.name}
          objective={site.objective}
          verificationDate={site.verificationDate}
          imageUrl={site.imageUrl}
          link={site.link}
          phone={site.phone}
        />
      ))}
    </div>
  );
}

export default TrustedSites;
